import { render, staticRenderFns } from "./SliderTableRow.vue?vue&type=template&id=4513317c&scoped=true&"
import script from "./SliderTableRow.vue?vue&type=script&lang=ts&"
export * from "./SliderTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4513317c",
  null
  
)

export default component.exports